import React, { useContext } from "react";

import { useSafeScroll } from "../../../lib/hooks/useScrollHandler";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

import Link from "../../Link";
import IconNavigation from "../IconNavigation/IconNavigation";
import NavigationMenuContext from "../NavigationMenuContext";
import GeneralPageContext from "../../../templates/GeneralPageContext";
import { SatelliteNavigation } from "../SatelliteNavigation/SatelliteNavigation";
import { PhoneContactButton } from "../PhoneContactButton/PhoneContactButton";

import LogoInfratec from "../../../../static/assets/logo-infratec.svg";

import * as styles from "./topBar.module.less";
import isInternalLink from "../../../lib/helper/isInternalLink";

export function TopBar({ satelliteMainNavElements }) {
    const {
        layout: { slimTopBar, showMainNavigation },
        entryPage
    } = useContext(GeneralPageContext);
    const { isMobile } = useContext(NavigationMenuContext);

    const isLandingPage = slimTopBar && !showMainNavigation;

    const scrollPositionReached = useSafeScroll(100);

    return (
        <div className={styles.topBar}>
            <div className={styles.topBarContainer}>
                <div className={styles.logoWrapper}>
                    <Link
                        to={
                            isLandingPage || !entryPage?.url
                                ? "#top"
                                : entryPage.url
                        }
                    >
                        <img
                            className={gcs(
                                styles.logo,
                                [
                                    scrollPositionReached && !isMobile,
                                    styles.onScroll
                                ],
                                [slimTopBar, styles.slim]
                            )}
                            src={LogoInfratec}
                            alt={"infratec"}
                        />
                    </Link>
                </div>

                <div className={styles.rightContainer}>
                    {slimTopBar ? (
                        <>
                            {showMainNavigation && isMobile ? (
                                <IconNavigation />
                            ) : (
                                <PhoneContactButton />
                            )}
                        </>
                    ) : (
                        <>
                            <IconNavigation className={styles.iconNavigation}/>
                            {!isMobile && (
                                <>
                                    <SatelliteNavigation
                                        className={styles.hideOnMobile}
                                        satelliteMainNavElements={
                                            satelliteMainNavElements
                                        }
                                    />
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
